import { FC } from 'react';

import { theme, Typography } from 'antd';
import { LinkProps } from 'antd/es/typography/Link';

interface IEllipsisLinkProps extends LinkProps {
	tooltip?: string;
	maxWidth?: number;
}

export const EllipsisLink: FC<IEllipsisLinkProps> = ({ className, children, tooltip, maxWidth = 200, ...props }) => {
	const {
		token: { colorPrimary },
	} = theme.useToken();

	return (
		<Typography.Text
			className={className}
			ellipsis={{ tooltip: tooltip || children }}
			style={{ maxWidth, color: colorPrimary }}>
			<Typography.Link {...props}>{children}</Typography.Link>
		</Typography.Text>
	);
};
